import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getAuthSession, clearAuthSession } from '../services/api';

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileNavActive, setIsMobileNavActive] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [authSession, setAuthSession] = useState(() => getAuthSession());

  useEffect(() => {
    const updateAuth = () => {
      setAuthSession(getAuthSession());
    };

    updateAuth();
    window.addEventListener('storage', updateAuth);
    window.addEventListener('auth-changed', updateAuth);
    return () => {
      window.removeEventListener('storage', updateAuth);
      window.removeEventListener('auth-changed', updateAuth);
    };
  }, [location.pathname]);

  const handleLogout = () => {
    clearAuthSession();
    setAuthSession(null);
    navigate('/login');
  };

  const getDashboardPath = () => {
    if (!authSession?.user) return '/login';
    if (authSession.user.role === 'admin') return '/admin-dashboard';
    if (authSession.user.role === 'physiotherapist') return '/physio-dashboard';
    return '/client-dashboard';
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 130);
      
      const scrollToTopButton = document.querySelector('.scroll-to-top');
      if (scrollToTopButton) {
        scrollToTopButton.style.display = window.scrollY > 100 ? 'inline-block' : 'none';
      }
    };

    const handleScrollToTop = (e) => {
      if (e.target.closest('.scroll-to-top')) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    window.addEventListener('scroll', handleScroll);
    document.addEventListener('click', handleScrollToTop);
    
    // Initialize WOW if available
    setTimeout(() => {
      if (window.WOW) {
        try { new window.WOW().init(); } catch (e) {}
      }
    }, 500);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('click', handleScrollToTop);
    };
  }, []);

  // Close mobile nav on route change
  useEffect(() => {
    setIsMobileNavActive(false);
  }, [location.pathname]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
  ];

  const renderNavList = () => (
    <ul className="main-menu__list">
      {navLinks.map((link) => {
        if (link.path === '/services') {
          return (
            <li key={link.path} className={`pm-nav-dropdown-item ${location.pathname === '/services' ? 'current' : ''}`}>
              <Link to="/services" style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                {link.name} <i className="fa-solid fa-chevron-down" style={{ fontSize: '10px', marginLeft: '4px', opacity: 0.7 }}></i>
              </Link>
              <div className="pm-mega-menu">
                <div className="pm-mega-grid">
                  <div>
                    <div className="pm-mega-col-title" style={{ color: '#7c3aed' }}>
                      <span>🧠</span> Psychological & Mental Health
                    </div>
                    <ul className="pm-mega-list">
                      <li><Link to="/services#psychological-mental-health"><i className="fa-solid fa-hands-holding-child" style={{ color: '#7c3aed', width: '16px' }}></i> Counselling Psychologist</Link></li>
                      <li><Link to="/services#psychological-mental-health"><i className="fa-solid fa-brain" style={{ color: '#7c3aed', width: '16px' }}></i> Clinical Psychologist</Link></li>
                      <li><Link to="/services#psychological-mental-health"><i className="fa-solid fa-user-doctor" style={{ color: '#7c3aed', width: '16px' }}></i> Psychiatrist</Link></li>
                      <li><Link to="/services#psychological-mental-health"><i className="fa-solid fa-wheelchair-move" style={{ color: '#7c3aed', width: '16px' }}></i> Rehabilitation Psychologist</Link></li>
                      <li><Link to="/services#psychological-mental-health"><i className="fa-solid fa-child-reaching" style={{ color: '#7c3aed', width: '16px' }}></i> Child Psychologist</Link></li>
                      <li><Link to="/services#psychological-mental-health"><i className="fa-solid fa-person-cane" style={{ color: '#7c3aed', width: '16px' }}></i> Geriatric Psychologist</Link></li>
                      <li><Link to="/services#psychological-mental-health"><i className="fa-solid fa-ribbon" style={{ color: '#7c3aed', width: '16px' }}></i> Psycho-Oncologist</Link></li>
                    </ul>
                  </div>

                  <div>
                    <div className="pm-mega-col-title" style={{ color: '#059669' }}>
                      <span>🌱</span> Development & Functional
                    </div>
                    <ul className="pm-mega-list">
                      <li><Link to="/services#development-functional"><i className="fa-solid fa-graduation-cap" style={{ color: '#059669', width: '16px' }}></i> Special Educator</Link></li>
                      <li><Link to="/services#development-functional"><i className="fa-solid fa-hand-holding-medical" style={{ color: '#059669', width: '16px' }}></i> Occupational Therapist</Link></li>
                      <li><Link to="/services#development-functional"><i className="fa-solid fa-comment-dots" style={{ color: '#059669', width: '16px' }}></i> Speech Therapist</Link></li>
                    </ul>
                  </div>

                  <div>
                    <div className="pm-mega-col-title" style={{ color: '#d97706' }}>
                      <span>🎯</span> Performance, Work & Education
                    </div>
                    <ul className="pm-mega-list">
                      <li><Link to="/services#performance-work-education"><i className="fa-solid fa-person-running" style={{ color: '#d97706', width: '16px' }}></i> Sports Psychologist</Link></li>
                      <li><Link to="/services#performance-work-education"><i className="fa-solid fa-compass" style={{ color: '#d97706', width: '16px' }}></i> Career Counsellor</Link></li>
                      <li><Link to="/services#performance-work-education"><i className="fa-solid fa-briefcase" style={{ color: '#d97706', width: '16px' }}></i> Organisational Psychologist</Link></li>
                      <li><Link to="/services#performance-work-education"><i className="fa-solid fa-bullseye" style={{ color: '#d97706', width: '16px' }}></i> Coach</Link></li>
                    </ul>
                  </div>
                </div>

                <div className="pm-mega-footer">
                  <span style={{ color: '#64748b' }}>Looking for personalized care?</span>
                  <Link to="/services">
                    Explore All 14 Specialities & Matcher →
                  </Link>
                </div>
              </div>
            </li>
          );
        }

        return (
          <li key={link.path} className={location.pathname === link.path ? 'current' : ''}>
            <Link to={link.path}>{link.name}</Link>
          </li>
        );
      })}
    </ul>
  );

  return (
    <>
      <style>
        {`
          .main-header-two { transition: all 0.3s ease; }
          .main-menu-two__wrapper {
            background: rgba(255, 255, 255, 0.85) !important;
            backdrop-filter: blur(15px);
            -webkit-backdrop-filter: blur(15px);
            border-bottom: 1px solid rgba(124, 58, 237, 0.1);
            position: relative;
            z-index: 1000;
          }
          .main-menu__list > li > a {
            position: relative;
            font-weight: 700;
            color: #2d2d4d !important;
            transition: color 0.3s ease;
            font-size: 1.05rem;
          }
          .main-menu__list > li > a:after {
            content: '';
            position: absolute;
            bottom: -5px;
            left: 0;
            width: 0;
            height: 2px;
            background: linear-gradient(90deg, #7c3aed, #4f46e5);
            transition: width 0.3s ease;
            border-radius: 2px;
          }
          .main-menu__list > li > a:hover:after { width: 100%; }
          .main-menu__list > li > a:hover { color: #7c3aed !important; }

          /* Dropdown Mega Menu for Services */
          .pm-nav-dropdown-item {
            position: relative;
          }

          .pm-mega-menu {
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%) translateY(12px);
            width: 780px;
            max-width: 92vw;
            background: #ffffff;
            border-radius: 20px;
            box-shadow: 0 20px 50px rgba(24, 17, 38, 0.16);
            border: 1.5px solid #ece4f8;
            padding: 24px;
            opacity: 0;
            visibility: hidden;
            pointer-events: none;
            transition: all 0.28s cubic-bezier(0.16, 1, 0.3, 1);
            z-index: 99999;
          }

          .pm-nav-dropdown-item:hover .pm-mega-menu {
            opacity: 1;
            visibility: visible;
            pointer-events: auto;
            transform: translateX(-50%) translateY(0);
          }

          .pm-mega-grid {
            display: grid;
            grid-template-columns: 1.15fr 1fr 1fr;
            gap: 18px;
            text-align: left;
          }

          .pm-mega-col-title {
            font-size: 12.5px;
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 0.6px;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            gap: 6px;
          }

          .pm-mega-list {
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: column;
            gap: 6px;
          }

          .pm-mega-list li {
            margin: 0;
            padding: 0;
          }

          .pm-mega-list li a {
            display: flex !important;
            align-items: center;
            gap: 8px;
            font-size: 13px !important;
            font-weight: 600 !important;
            color: #4b3e64 !important;
            text-decoration: none !important;
            padding: 5px 8px !important;
            border-radius: 8px;
            transition: all 0.2s ease;
            white-space: nowrap;
          }

          .pm-mega-list li a:after {
            display: none !important;
          }

          .pm-mega-list li a:hover {
            background: #f6f0ff;
            color: #7c4bb9 !important;
            transform: translateX(3px);
          }

          .pm-mega-footer {
            margin-top: 16px;
            padding-top: 12px;
            border-top: 1px solid #f0eaf8;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 13px;
          }

          .pm-mega-footer a {
            font-weight: 700 !important;
            color: #7c4bb9 !important;
            text-decoration: none !important;
            transition: transform 0.2s ease;
          }

          .pm-mega-footer a:after {
            display: none !important;
          }

          .pm-mega-footer a:hover {
            transform: translateX(3px);
          }

          .thm-btn--header {
            padding: 10px 24px !important;
            font-size: 0.95rem !important;
            font-weight: 700 !important;
            border-radius: 12px !important;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
            box-shadow: 0 4px 12px rgba(124, 58, 237, 0.15) !important;
          }
          .thm-btn--header:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(124, 58, 237, 0.25) !important;
          }
          .stricky-fixed {
            background: rgba(255, 255, 255, 0.9) !important;
            backdrop-filter: blur(20px) !important;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05) !important;
          }
          .main-menu-two__logo img { transition: transform 0.3s ease; }
          .main-menu-two__logo:hover img { transform: scale(1.05); }

          .page-header {
            position: relative;
            padding: 120px 0 90px !important;
            overflow: hidden;
            background-color: #1a1a2e;
          }
          .page-header__bg {
            filter: brightness(0.7) contrast(1.1);
            transform: scale(1.05);
            transition: transform 10s linear;
            position: absolute;
            top: 0; left: 0; width: 100%; height: 100%;
            background-size: cover;
            background-position: center;
          }
          .page-header:hover .page-header__bg { transform: scale(1.15); }
          .page-header:before {
            content: '';
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background: linear-gradient(180deg, rgba(124, 58, 237, 0.4) 0%, rgba(31, 41, 55, 0.85) 100%);
            z-index: 1;
          }
          .page-header__inner { position: relative; z-index: 2; text-align: center; }
          .page-header__title {
            font-size: 4rem !important;
            font-weight: 900 !important;
            color: #ffffff !important;
            text-shadow: 0 10px 30px rgba(0,0,0,0.3);
            letter-spacing: -1px;
            margin-bottom: 20px !important;
            animation: fadeInUp 0.8s ease-out;
          }
          .thm-breadcrumb {
            display: inline-flex !important;
            align-items: center;
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            padding: 8px 24px !important;
            border-radius: 50px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            animation: fadeInUp 1s ease-out;
          }
          .thm-breadcrumb li, .thm-breadcrumb li a, .thm-breadcrumb li span {
            color: rgba(255, 255, 255, 0.9) !important;
            font-weight: 600 !important;
            font-size: 0.95rem !important;
          }
          .thm-breadcrumb li a:hover { color: #7c3aed !important; }
          .page-header:after {
            content: '🌿';
            position: absolute;
            top: 20%; right: 10%;
            font-size: 3rem;
            opacity: 0.1;
            filter: blur(2px);
            animation: float-y 6s infinite ease-in-out;
            z-index: 1;
          }
          @keyframes float-y { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-30px); } }
          @keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        `}
      </style>

      {/* Sticky Header */}
      <div className={`stricky-header stricked-menu main-menu ${isSticky ? 'stricky-fixed' : ''}`}>
        <div className="sticky-header__content">
            <nav className="main-menu main-menu-two">
                <div className="main-menu-two__wrapper">
                    <div className="main-menu-two__wrapper-inner">
                        <div className="main-menu-two__logo">
                            <Link to="/"><img src="/assets/images/PsychMitra.png" alt="" style={{ height: '70px' }} /></Link>
                        </div>
                        <div className="main-menu-two__main-menu-box">
                            {renderNavList()}
                        </div>
                    </div>
                </div>
            </nav>
        </div>
      </div>

      <header className="main-header-two">
        <nav className="main-menu main-menu-two">
          <div className="main-menu-two__wrapper">
            <div className="main-menu-two__wrapper-inner">
              <div className="main-menu-two__logo">
                <Link to="/"><img src="/assets/images/PsychMitra.png" alt="" style={{ height: '90px' }} /></Link>
              </div>
              <div className="main-menu-two__main-menu-box">
                {renderNavList()}
              </div>
              <div className="main-menu-two__right">
                {authSession?.token ? (
                  <>
                    <Link to={getDashboardPath()} className="thm-btn thm-btn--header" style={{ marginRight: '10px', background: 'linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%)', color: '#fff' }}>
                      🧑‍💻 Dashboard
                    </Link>
                    <button onClick={handleLogout} className="thm-btn thm-btn--header" style={{ background: 'transparent', border: '2px solid #ef4444', color: '#ef4444', cursor: 'pointer' }}>
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <Link to="/login" className="thm-btn thm-btn--header" style={{ marginRight: '15px', background: 'transparent', border: '2px solid #7c3aed', color: '#7c3aed' }}>
                      Login
                    </Link>
                    <Link to="/register" className="thm-btn thm-btn--header" style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%)', color: '#fff' }}>
                      Register Now
                    </Link>
                  </>
                )}
                <div className="mobile-nav__toggler" onClick={() => setIsMobileNavActive(true)} style={{ marginLeft: '15px', cursor: 'pointer', fontSize: '24px' }}>
                    <i className="fa fa-bars"></i>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Mobile Nav */}
      <div className={`mobile-nav__wrapper ${isMobileNavActive ? 'mobile-nav__wrapper--active' : ''}`}>
        <div className="mobile-nav__overlay" onClick={() => setIsMobileNavActive(false)}></div>
        <div className="mobile-nav__content">
          <span className="mobile-nav__close" onClick={() => setIsMobileNavActive(false)}><i className="fa fa-times"></i></span>
          <div className="logo-box">
            <Link to="/"><img src="/assets/images/PsychMitra.png" alt="Logo" style={{ maxHeight: '100px', width: 'auto' }} /></Link>
          </div>
          <div className="mobile-nav__container">
              <ul className="main-menu__list">
                {navLinks.map(link => (
                    <li key={link.path}><Link to={link.path}>{link.name}</Link></li>
                ))}
              </ul>
              <div style={{ padding: '20px 0', borderTop: '1px solid rgba(255,255,255,0.15)', marginTop: '15px' }}>
                {authSession?.token ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <Link
                      to={getDashboardPath()}
                      className="thm-btn thm-btn--header"
                      style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%)', color: '#fff', textAlign: 'center' }}
                      onClick={() => setIsMobileNavActive(false)}
                    >
                      🧑‍💻 Dashboard
                    </Link>
                    <button
                      onClick={() => {
                        setIsMobileNavActive(false);
                        handleLogout();
                      }}
                      className="thm-btn thm-btn--header"
                      style={{ background: 'transparent', border: '2px solid #ef4444', color: '#ef4444', cursor: 'pointer', textAlign: 'center' }}
                    >
                      Logout
                    </button>
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <Link
                      to="/login"
                      className="thm-btn thm-btn--header"
                      style={{ background: 'transparent', border: '2px solid #7c3aed', color: '#7c3aed', textAlign: 'center' }}
                      onClick={() => setIsMobileNavActive(false)}
                    >
                      Login
                    </Link>
                    <Link
                      to="/register"
                      className="thm-btn thm-btn--header"
                      style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%)', color: '#fff', textAlign: 'center' }}
                      onClick={() => setIsMobileNavActive(false)}
                    >
                      Register Now
                    </Link>
                  </div>
                )}
              </div>
          </div>
          <ul className="mobile-nav__contact list-unstyled">
            <li><i className="fa fa-envelope"></i> <a href="mailto:help@psychmitra.com">help@psychmitra.com</a></li>
            <li><i className="fa fa-phone-alt"></i> <a href="tel:9288009850">+92 (8800) - 9850</a></li>
          </ul>
          <div className="mobile-nav__social">
              <a href="#" className="fab fa-twitter"></a>
              <a href="#" className="fab fa-facebook-square"></a>
              <a href="#" className="fab fa-instagram"></a>
          </div>
        </div>
      </div>

      <a href="#top" className="scroll-to-target scroll-to-top" style={{ display: 'none' }}><i className="icon-up-arrow"></i></a>
    </>
  );
}

export default Header;
